import PropTypes from 'prop-types';
export var fieldPropTypes = {
    addLabel: PropTypes.bool,
    sortBy: PropTypes.string,
    source: PropTypes.string,
    label: PropTypes.string,
    sortable: PropTypes.bool,
    className: PropTypes.string,
    cellClassName: PropTypes.string,
    headerClassName: PropTypes.string,
    textAlign: PropTypes.oneOf(['right', 'left']),
    emptyText: PropTypes.string,
    fieldKey: PropTypes.string,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-ui-materialui/esm/field/types.js
// module id = 34
// module chunks = 0